module.exports = __webpack_public_path__ + "fonts/SofiaProExtraLight-Italic.3e3f9ede.eot";